import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import HomePage from '../HomePage'
import {
  captureVisitorFromParam,
  slugifyName,
} from '../../lib/visitorContext'
import { logVisitorIdentified } from '../../supabaseTracker'

export default function HiHomePage() {
  const { visitorName } = useParams()
  const slug = slugifyName(visitorName)

  useEffect(() => {
    if (!slug) return
    const isNew = captureVisitorFromParam(slug)
    if (isNew) {
      logVisitorIdentified(slug).catch(() => {})
    }
  }, [slug])

  return <HomePage visitorSlug={slug} />
}
